import React, { Component } from 'react';
import AdminAPI from './AdminAPI';
import { findMissingStatSettings } from './levelStatIntegrity';

function MissingStatReferences({
    entries,
    settingsKey,
    settingLabel,
    onRemove,
}) {
    if (entries.length === 0) {
        return null;
    }

    return (
        <div className="admin-level__missing-references">
            {entries.map((entry, index) => {
                const statId = entry?.statId || '(empty Stat ID)';
                const removeLabel = `Remove missing ${settingLabel.toLowerCase()} reference ${statId}`;
                return (
                    <article
                        className="admin-level__missing-reference"
                        key={`${statId}-${index}`}
                    >
                        <div>
                            <strong>Missing stat reference</strong>
                            <code>{statId}</code>
                            <p>
                                This saved {settingLabel.toLowerCase()} points to a stat
                                that no longer exists.
                            </p>
                            <small>
                                From {entry?.valueFrom ?? 0} to {entry?.valueTo ?? 0}
                            </small>
                        </div>
                        <button
                            className="button-critical"
                            type="button"
                            aria-label={removeLabel}
                            onClick={() => onRemove(settingsKey, entry)}
                        >
                            Remove reference
                        </button>
                    </article>
                );
            })}
        </div>
    );
}

export default class LevelDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageFile: null,
            Level: null,
        };
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (this.props.LevelId !== prevProps.LevelId || this.props.creatingNewLevel !== prevProps.creatingNewLevel) {
            this.getLevel();
        }
    }

    getLevel = async () => {
        if (this.props.LevelId != null) {
            if (this.props.LevelId === "") {
                this.setState({ Level: { name: "", shortName: "", flavourText: "", LevelNumber: 1, itemStatSettings: [], enemyStatSettings: [] }, imageFile: null, imagePreviewUrl: "" });
            } else {
                var lvl = await AdminAPI.getLevel(this.props.LevelId);
                this.setState({ Level: lvl });
                // const response = await apiGet("/Level/" + this.props.LevelId);
                // if (response.ok) {
                //     const curr = await response.json();
                //     this.setState({ Level: curr });
                if (lvl.imageId) {
                    this.fetchImage();
                }
                // }
            }
        } else {
            this.setState({ Level: null });
        }
    }

    handleInputChange = (event) => {
        const name = event.target.name;
        let value = event.target.value;
        if (event.target.type === "checkbox") {
            value = event.target.checked;
        } else if (event.target.type === "number") {
            value = parseFloat(event.target.value);
        } else {
            value = event.target.value;
        }
        const Level = { ...this.state.Level, [name]: value };
        this.setState({ Level });
    };

    // handleStatChange = (index, type, event) => {
    //     const { name, value } = event.target;
    //     const Level = { ...this.state.Level };
    //     Level[type][index][name] = value;
    //     this.setState({ Level });
    // };
    handleStatsChange = (event, stat) => {
        const name = event.target.name;
        console.log(name);
        const nameValues = name.split("_$$_");
        console.log(nameValues);
        const parsedValue = Number.parseFloat(event.target.value);
        const value = event.target.type === "checkbox"
            ? event.target.checked
            : (Number.isFinite(parsedValue) ? parsedValue : 0);



        let stats = this.state.Level[nameValues[0]];
        console.log(stats);
        if (stats === null) {
            stats = [];
            let se = { statId: stat.id, valueFrom: 0, valueTo: 0, statType: stat.statType }
            se = { name: nameValues[1], [nameValues[2]]: value };
            stats.push(se);
        }
        else {
            let se = stats?.find(entry => entry.statId === nameValues[1]);

            console.log(nameValues[1]);

            if (se)
                se[nameValues[2]] = value;
            else {
                se = { name: nameValues[1], [nameValues[2]]: value };
                stats.push(se);
            }

        }
        this.setState({ Level: { ...this.state.Level, [nameValues[0]]: stats } });
    };

    addAnotherStat = (event) => {
        let statId = event.target.value;
        let stat = this.props.stats.find(x => x.id === statId);
        if (!stat) {
            return;
        }
        let se = {
            statId: stat.id,
            valueFrom: 0,
            valueTo: 0,
            affixEnabled: true,
        };
        let stats;
        if (event.target.name === "itemStatSettings") {
            stats = this.state.Level.itemStatSettings;
        } else {
            stats = this.state.Level.enemyStatSettings;
        }
        if (stats == null) {
            stats = [];
        }


        stats.push(se);

        this.setState({ Level: { ...this.state.Level, [event.target.name]: stats } });
    }

    removeStat = (settingsKey, statEntry) => {
        this.setState(prevState => {
            const currentLevel = prevState.Level;
            if (!currentLevel) {
                return null;
            }

            const currentStats = currentLevel[settingsKey];
            if (!Array.isArray(currentStats)) {
                return null;
            }

            const updatedStats = currentStats.filter(entry => entry !== statEntry);
            if (updatedStats.length === currentStats.length) {
                return null;
            }

            return {
                Level: {
                    ...currentLevel,
                    [settingsKey]: updatedStats,
                },
            };
        });
    }

    render() {
        const { onUpdate, onDelete, onCreate, creatingNewLevel, onCancelCreate, stats } = this.props;
        const { Level } = this.state;

        if (!Level || Level == null) return <div>Select a Level to see details</div>;

        const missingItemStats = findMissingStatSettings(
            Level.itemStatSettings,
            stats,
        );
        const missingEnemyStats = findMissingStatSettings(
            Level.enemyStatSettings,
            stats,
        );
        const missingStatCount = missingItemStats.length + missingEnemyStats.length;

        return (
            <div className='admin_details'>

                <label>Level Number:
                    <input type="number" name="levelNumber" value={Level.levelNumber} onChange={this.handleInputChange} />
                </label>

                {missingStatCount > 0 && (
                    <div className="admin-level__integrity-alert" role="alert">
                        <strong>
                            {missingStatCount} broken stat {missingStatCount === 1 ? 'reference' : 'references'}
                        </strong>
                        <span>
                            Remove the missing rows below, then save this level to
                            repair the catalog.
                        </span>
                    </div>
                )}

                <div className='section2'>
                    <h3>Item Stat Settings</h3>
                    <MissingStatReferences
                        entries={missingItemStats}
                        settingsKey="itemStatSettings"
                        settingLabel="Item stat setting"
                        onRemove={this.removeStat}
                    />
                    {stats.map((obj, index) => {
                        // const foundStat = item.stats?.statEntries.find(x => x.name === obj.name);
                        const foundStats = Level.itemStatSettings?.filter(x => x.statId === obj.id);
                        return foundStats?.map((foundStat, foundIndex) => {
                            return (
                                <label key={`${obj.id}-${foundIndex}`}>{obj.name}:
                                    {(obj.statType === 0) ? //Stat
                                        <div className='statEntryDefinition'>
                                            <div className='statEntryDefinitionValue'><label>From:</label><div className='inoutAndUnitSymbol'><input type="number" step="any" name={"itemStatSettings_$$_" + obj.id + "_$$_valueFrom"} value={foundStat.valueFrom ?? 0} onChange={(e) => this.handleStatsChange(e, obj)} />{obj.unitSymbol}</div></div>
                                            <div className='statEntryDefinitionValue'><label>To: </label><div className='inoutAndUnitSymbol'><input type="number" step="any" name={"itemStatSettings_$$_" + obj.id + "_$$_valueTo"} value={foundStat.valueTo ?? 0} onChange={(e) => this.handleStatsChange(e, obj)} />{obj.unitSymbol}</div></div>
                                            <div className='statEntryDefinitionValue'><label>Affix enabled at this level:<input type="checkbox" name={"itemStatSettings_$$_" + obj.id + "_$$_affixEnabled"} checked={foundStat.affixEnabled !== false} onChange={(e) => this.handleStatsChange(e, obj)} /></label></div>
                                            <div className='statEntryDefinitionValue'><button type="button" onClick={() => this.removeStat('itemStatSettings', foundStat)}>delete</button></div>
                                        </div>
                                        : // Proc
                                        <div className='statEntryDefinition'>
                                            <div className='statEntryDefinitionValue'><label>From: </label><div className='inoutAndUnitSymbol'><input type="number" step="any" name={"itemStatSettings_$$_" + obj.id + "_$$_valueFrom"} value={foundStat.valueFrom ?? 0} onChange={(e) => this.handleStatsChange(e, obj)} />{obj.unitSymbol}</div></div>
                                            <div className='statEntryDefinitionValue'><label>To: </label><div className='inoutAndUnitSymbol'><input type="number" step="any" name={"itemStatSettings_$$_" + obj.id + "_$$_valueTo"} value={foundStat.valueTo ?? 0} onChange={(e) => this.handleStatsChange(e, obj)} />{obj.unitSymbol}</div></div>
                                            <div className='statEntryDefinitionValue'><label>ProcPercent:</label><div className='inoutAndUnitSymbol'><input type="number" name={"itemStatSettings_$$_" + obj.id + "_$$_procPercent"} value={foundStat.procPercent ?? 0} onChange={(e) => this.handleStatsChange(e, obj)} />%</div></div>
                                            <div className='statEntryDefinitionValue'><label>Affix enabled at this level:<input type="checkbox" name={"itemStatSettings_$$_" + obj.id + "_$$_affixEnabled"} checked={foundStat.affixEnabled !== false} onChange={(e) => this.handleStatsChange(e, obj)} /></label></div>
                                            <div className='statEntryDefinitionValue'><button type="button" onClick={() => this.removeStat('itemStatSettings', foundStat)}>delete</button></div>

                                        </div>


                                    }

                                </label>);
                        });
                    })}
                    {/* {Level.itemStatSettings?.map((stat, index) => (
                        <div key={index}>
                            <label>StatId:
                                <input type="text" name="StatId" value={stat.StatId} onChange={(e) => this.handleStatChange(index, 'itemStatSettings', e)} />
                            </label>
                            <label>ValueFrom:
                                <input type="number" name="ValueFrom" value={stat.ValueFrom} onChange={(e) => this.handleStatChange(index, 'itemStatSettings', e)} />
                            </label>
                            <label>ValueTo:
                                <input type="number" name="ValueTo" value={stat.ValueTo} onChange={(e) => this.handleStatChange(index, 'itemStatSettings', e)} />
                            </label>
                        </div>
                    ))} */}
                    <div><label>Add another stat/proc:</label>
                        <select
                            name="itemStatSettings"
                            value={0}
                            onChange={this.addAnotherStat}
                        >
                            <option key={-1} value="default">Add Stat</option>
                            {stats.map((obj, index) =>
                                <option key={index} value={obj.id}>{obj.name}</option>
                            )}

                        </select>
                    </div>
                </div>

                <div className='section2'>
                    <h3>Enemy Stat Settings</h3>
                    <MissingStatReferences
                        entries={missingEnemyStats}
                        settingsKey="enemyStatSettings"
                        settingLabel="Enemy stat setting"
                        onRemove={this.removeStat}
                    />
                    {stats.map((obj, index) => {
                        // const foundStat = item.stats?.statEntries.find(x => x.name === obj.name);
                        const foundStats = Level.enemyStatSettings?.filter(x => x.statId === obj.id);
                        return foundStats?.map((foundStat, foundIndex) => {
                            return (
                                <label key={`${obj.id}-${foundIndex}`}>{obj.name}:
                                    {(obj.statType === 0) ? //Stat
                                        <div className='statEntryDefinition'>
                                            <div className='statEntryDefinitionValue'><label>From:</label><div className='inoutAndUnitSymbol'><input type="number" step="any" name={"enemyStatSettings_$$_" + obj.id + "_$$_valueFrom"} value={foundStat.valueFrom ?? 0} onChange={(e) => this.handleStatsChange(e, obj)} />{obj.unitSymbol}</div></div>
                                            <div className='statEntryDefinitionValue'><label>To: </label><div className='inoutAndUnitSymbol'><input type="number" step="any" name={"enemyStatSettings_$$_" + obj.id + "_$$_valueTo"} value={foundStat.valueTo ?? 0} onChange={(e) => this.handleStatsChange(e, obj)} />{obj.unitSymbol}</div></div>
                                            <div className='statEntryDefinitionValue'><button type="button" onClick={() => this.removeStat('enemyStatSettings', foundStat)}>delete</button></div>
                                        </div>
                                        : // Proc
                                        <div className='statEntryDefinition'>
                                            <div className='statEntryDefinitionValue'><label>From: </label><div className='inoutAndUnitSymbol'><input type="number" step="any" name={"enemyStatSettings_$$_" + obj.id + "_$$_valueFrom"} value={foundStat.valueFrom ?? 0} onChange={(e) => this.handleStatsChange(e, obj)} />{obj.unitSymbol}</div></div>
                                            <div className='statEntryDefinitionValue'><label>To: </label><div className='inoutAndUnitSymbol'><input type="number" step="any" name={"enemyStatSettings_$$_" + obj.id + "_$$_valueTo"} value={foundStat.valueTo ?? 0} onChange={(e) => this.handleStatsChange(e, obj)} />{obj.unitSymbol}</div></div>
                                            <div className='statEntryDefinitionValue'><label>ProcPercent:</label><div className='inoutAndUnitSymbol'><input type="number" name={"enemyStatSettings_$$_" + obj.id + "_$$_procPercent"} value={foundStat.procPercent ?? 0} onChange={(e) => this.handleStatsChange(e, obj)} />%</div></div>
                                            <div className='statEntryDefinitionValue'><button type="button" onClick={() => this.removeStat('enemyStatSettings', foundStat)}>delete</button></div>

                                        </div>


                                    }

                                </label>);
                        });
                    })}


                    {/* {Level.EnemyStatSettings?.map((stat, index) => (
                        <div key={index}>
                            <label>StatId:
                                <input type="text" name="StatId" value={stat.StatId} onChange={(e) => this.handleStatChange(index, 'EnemyStatSettings', e)} />
                            </label>
                            <label>ValueFrom:
                                <input type="number" name="ValueFrom" value={stat.ValueFrom} onChange={(e) => this.handleStatChange(index, 'EnemyStatSettings', e)} />
                            </label>
                            <label>ValueTo:
                                <input type="number" name="ValueTo" value={stat.ValueTo} onChange={(e) => this.handleStatChange(index, 'EnemyStatSettings', e)} />
                            </label>
                        </div>
                    ))} */}
                    <div><label>Add another stat/proc:</label>
                        <select
                            name="enemyStatSettings"
                            value={0}
                            onChange={this.addAnotherStat}
                        >
                            <option key={-1} value="default">Add Stat</option>
                            {stats.map((obj, index) =>
                                <option key={index} value={obj.id}>{obj.name}</option>
                            )}

                        </select>
                    </div>
                </div>

                {creatingNewLevel ?
                    <div>
                        <button onClick={() => onCreate(Level)}>Create</button>
                        <button onClick={() => onCancelCreate()}>Cancel</button>
                    </div>
                    :
                    <div>
                        <button onClick={() => onUpdate(Level)}>Save Level</button>
                        <button onClick={() => onDelete(Level)}>Delete</button>
                    </div>
                }
            </div>
        );
    }
}
